const NAMESPACE = "image";

const KEYS = {
    noImageSelectedText: "noImageSelectedText",
    attachmentPlaceholderText: "attachmentPlaceholderText"
};

const MESSAGES = {
    [KEYS.noImageSelectedText]: {
        value: "No image selected",
        comment: "Error message displayed when an image is not properly configured."
    },
    [KEYS.attachmentPlaceholderText]: {
        value: "Attachment will display after upload",
        comment: "Explanatory text shown on the Edit Form page when the image source is set to an attachment."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
